<template>
    <div id="app">
        <!-- <keep-alive> -->
        <router-view />
        <!-- </keep-alive> -->
    </div>
</template>
<script>

export default {
    created() {
        if (this.isMobile()) {
            location.href = `${this.pub.config.wapPms}`;
        }
    },
    mounted(){
        this.watchUpdate()
    },
    methods: {
        updateSession(version){
            sessionStorage.setItem('version', version)
            location.reload()
        },
        watchUpdate() {
            window.addEventListener("onmessageUpdate", (res) => {
            console.log(res.detail.version,"🚀 ~ file: App.vue:20 ~ window.addEventListener ~ res:", res)
            let version = res.detail.version
            const h = this.$createElement;
            this.$message({
                duration: 0,
                dangerouslyUseHTMLString: true,
                type: 'warning',
                customClass: 'versionMes',
                message: h('p', null, [
                    h('div', {style: {fontWeight:'600'},},' 發現新版本！'),
                    h('div', null,'  點擊立即更新，享受更好的使用體驗。'),
                    h('el-button', 
                        {on: {click: ()=>{
                            sessionStorage.setItem('version', version)
                            location.reload()
                        }},attrs: {type: 'primary'},
                        style: {
                            height:'38px',
                            display: 'inline-block',
                            color: '#fff',
                            position: 'absolute',
                            top: '21px',
                            right: '18px',
                            borderRadius:'10px'
                        },},
                    '立即更新',),
                ]),
            });
        })
      },

        isMobile() {
            if (this.$route.query.desktop == 1) {
                return;
            }
            if (location.href.indexOf('qrCodeDownload') !== -1) {
                return;
            }
            let flag = navigator.userAgent.match(/(phone|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);

            /*如果是手机端访问appdownload页面 拦截跳转到wap站 ==直接唤醒手机app*/
            if (location.href.indexOf('appdownload') > -1 && flag) {
                const u = navigator.userAgent.toLowerCase();
                if (u.includes('ios') || u.includes('iphone')) {
                    location.href = `https://apps.apple.com/hk/app/id1492668798`;
                } else {
                    location.href = `https://play.google.com/store/apps/details?id=com.house730.pms`;
                }
                return;
            }
            return flag;
        }
    }
};
</script>
<style lang="less">

.versionMes{
    width:500px;
    height:80px;
    background: #FFF9ED;
    top:55px !important;
    border: 1px solid #E1C999;
    border-radius:6px;
    div{
        font-size:18px;
        color:#444444;
    }
    /deep/.el-icon-warning{
        color:none !important;
        font-size:22px !important;
    }
}
body {
    min-width: 1080px;
}
p {
    margin: 0;
    padding: 0;
}
html,
body,
#app,
.el-container {
    margin: 0;
    padding: 0;
    height: 100%;
    width: 100%;
}
a {
    text-decoration: none;
}

#app {
    // font-family: "Avenir", Helvetica, Arial, sans-serif;
    font-family: 'Microsoft YaHei', 'Microsoft JhengHei', 'SimSun', Arial, Helvetica, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

#nav {
    padding: 30px;
}

#nav a {
    font-weight: bold;
    color: #2c3e50;
}

#nav a.router-link-exact-active {
    color: #42b983;
}
</style>
